(() => {
  // --- Sticky video ---
  function updateStickyTop(sticky) {
    const h = sticky.offsetHeight;
    if (h === 0) return;
    sticky.style.top = `calc(50vh - ${h / 2}px)`;
  }

  function initSticky() {
    document.querySelectorAll('.video-with-text__media-sticky').forEach(sticky => {
      const ro = new ResizeObserver(() => updateStickyTop(sticky));
      ro.observe(sticky);
    });
  }

  // --- Carousel nav ---
  function initCarousels() {
    document.querySelectorAll('.video-with-text__carousel-wrapper').forEach(wrapper => {
      const carousel = wrapper.querySelector('[data-carousel]');
      const btns = wrapper.querySelectorAll('[data-direction]');
      if (!carousel || !btns.length) return;

      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          const dir = btn.dataset.direction === 'next' ? 1 : -1;
          carousel.scrollBy({ left: dir * carousel.offsetWidth, behavior: 'smooth' });
        });
      });
    });
  }

  function init() {
    initSticky();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
